import apiSlice from 'renderer/shared/state/apiSlice';
import {
  GetConfigRequest,
  GetConfigResponse,
  GetConfigResponseSchema,
  PurchaseRequest,
  PurchaseResponse,
  PurchaseResponseSchema,
} from '../schemas/purchase.schemas';
import {
  GetPriceRequest,
  GetPriceResponse,
  PricesSchema,
} from '../schemas/prices.schema';

const extendedApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    makePurchase: builder.mutation<PurchaseResponse, PurchaseRequest>({
      query: (body) => ({
        url: '/transaction/sale',
        body,
        method: 'POST',
      }),
      invalidatesTags: ['PaymentMethods', 'User', 'Notification'],
      // extraOptions: {
      //   responseSchema: PurchaseResponseSchema,
      // },
    }),
    getConfig: builder.query<GetConfigResponse, GetConfigRequest>({
      query: () => '/config',
      extraOptions: {
        responseSchema: GetConfigResponseSchema,
      },
    }),
    getPrice: builder.query<GetPriceResponse, GetPriceRequest>({
      query: (params) => ({
        url: '/price',
        params,
        method: 'GET',
      }),
      extraOptions: {
        responseSchema: PricesSchema,
      },
    }),
  }),
});

export const { useMakePurchaseMutation, useGetConfigQuery, useGetPriceQuery } =
  extendedApi;
